/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Chegar ao destino
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 12/04/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.ArriveDestination = function (
  {
    parentSelector = '#RouteSummary',
    successCallback
  } = {}
) {

    this.modalForm = null;
    this.route = null;
    this.blockOverlaySelector = '.mainContainer';

    this.getLayoutArriveDestinationFormTemplate = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": Monet.I18n.getResourcesByKey("greenmile.route.arrivedestination.btnsave"),
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },


                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": data.dateTimeField.name,
                                                        "value": data.dateTimeField.value,
                                                        "name": data.dateTimeField.name,
                                                        "class": "dateTimePicker"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.drivers.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.drivers.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": data.drivers.name,
                                                        "id": data.drivers.name
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnSaveValue,
                                                        "name": "btn_save_arriveDestination_stop",
                                                        "id": "btn_save_arriveDestination_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnExitValue,
                                                        "name": "btn_exit_arriveDestination_stop",
                                                        "id": "btn_exit_arriveDestination_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formArriveDestinationFormTemplate"
                    }
                }
            ]
        }).render();
    };

    this.getLayoutArriveDestinationFormTemplatePendingStops = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": Monet.I18n.getResourcesByKey("greenmile.route.arrivedestination.btnsave"),
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },


                                                }
                                            ]
                                        },
                                        {
                                            "tag": "h4",
                                            "html": data.pendingListTitle,
                                            "attributes": {
                                                "style": "padding: 10px 15px 0 15px;"
                                            }
                                        },
                                        {
                                            "beforeHtml": data.pendingListStopHTML,
                                            "attributes": {
                                                "class": "pendingStopsList"
                                            }
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.cancelCodes.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.cancelCodes.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": data.cancelCodes.name,
                                                        "id": data.cancelCodes.name
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": data.dateTimeField.name,
                                                        "value": data.dateTimeField.value,
                                                        "name": data.dateTimeField.name,
                                                        "class": "dateTimePicker"
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnSaveValue,
                                                        "name": "btn_save_arriveDestinationPendingStops_stop",
                                                        "id": "btn_save_arriveDestinationPendingStops_stop",
                                                        "class": "btn"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnExitValue,
                                                        "name": "btn_exit_arriveDestinationPendingStops_stop",
                                                        "id": "btn_exit_arriveDestinationPendingStops_stop",
                                                        "class": "btn secondary"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formArriveDestinationFormTemplate"
                    }
                }
            ]
        }).render();
    };

    var renderContentListStops = function (context) {

        return function () {
            var html        = document.createElement("div"),
                span        = null,
                key         = null,
                description = null,
                location    = null,
                pendingList = context.pendingList;


            for (var i = 0, len = pendingList.length; i < len; i++) {
                span = document.createElement("span");
                span.id = 'pending_' + pendingList[i].get("id");

                key = document.createElement("div");
                key.className = "pendingStopsListKey";

                description = document.createElement("div");
                description.className = "pendingStopsListDescription";

                location = pendingList[i].get("location");

                if (location) {
                    key.insertAdjacentHTML("afterbegin", location.key);
                    const descriptionLabel = location.description || `<i class="muted">${Monet.I18n.getResourcesByKey("Greenmile.Route.ArriveDestination.locationDescription.undefined")}</i>`;
                    description.insertAdjacentHTML("afterbegin", descriptionLabel);
                } else {
                    key.insertAdjacentHTML("afterbegin", pendingList[i].get("key"));
                    description.insertAdjacentHTML("afterbegin", Monet.I18n.getResourcesByKey("EventNotification.noLocationFound"));
                }


                span.appendChild(key);
                span.appendChild(description);
                html.appendChild(span);
            }

            return html.innerHTML;

        };

    }(this);

    var showLoading = function () {

        var classLoading = document.createElement('div');
        var iconImg = document.createElement('img');
        var closeBtn;
        var popup;
        var form;

        classLoading.className = "loadingPopupFormContainer";
        iconImg.src = require("static/images/general/loading_blue.svg");
        classLoading.appendChild(iconImg);

        popup = document.querySelector(`${parentSelector} .popupFormContainer`);
        form = document.getElementById('formArriveDestinationFormTemplate');
        closeBtn = document.querySelector(`${parentSelector} .closeModalWindow`);

        if (closeBtn) {
            closeBtn.style.display = 'none';
        }

        if (form) {
            form.style.display = 'none';
        }

        if (popup) {
            popup.appendChild(classLoading);
        }

    };

    var destroyLoading = function () {
        var image;
        var form;
        var parentNode;
        var closeBtn;

        form = document.getElementById('formArriveDestinationFormTemplate');
        closeBtn = document.querySelector(`${parentSelector} .closeModalWindow`);
        image = document.querySelector(`${parentSelector} .popupFormContainer .loadingPopupFormContainer`);

        if (form) {
            form.style.display = 'block';
        }

        if (closeBtn) {
            closeBtn.style.display = 'block';
        }

        if (image) {

            parentNode = image.parentNode;

            if (parentNode) {
                parentNode.removeChild(image);
            }
        }


    };

    this.setRoute = function (route) {
        this.route = route;
    };

    this.getFormValues = function () {

        var arriveDestinationTimeField = document.querySelector("#formArriveDestinationFormTemplate .dateTimePicker");
        var driver = document.getElementById("driversList");
        var formattedDate = Monet.Format.DateTime.parseLocaleToISOString(arriveDestinationTimeField.value);

        var driverId = "";

        if (driver !== null) {
            driverId = driver.value;
        }

        return {
            actualArrival: formattedDate,
            driverId: driverId
        };
    };


    this.getPendingStops = function (stops) {

        var stopsToCancel = [];

        for (var i = 0, j = stops.size(); i < j; i++) {

            if (typeof stops.at(i).get("actualDeparture") === "undefined" &&
                typeof stops.at(i).get("cancelCode") === "undefined") {

                stopsToCancel.push(stops.at(i));

            }

        }

        return stopsToCancel;

    };

    this.setPendingList = function (pendingStopsArray) {
        this.pendingList = pendingStopsArray;
    };


    this.loadRouteStops = function (callbacks) {

        var pendingStopsArray = [];

        this.route.stops({

            criteria: '{"filters":["*", "location.locationType.*", "location.*","stopType.*","cancelCode.*","redeliveryStop.*","redeliveryStop.location.key*", "undeliverableCode.*"]}',

            success: function (data) {

                if (callbacks) {

                    if (callbacks.analizeData) {
                        pendingStopsArray = callbacks.analizeData(data);
                    }

                    if (pendingStopsArray.length > 0 && callbacks.pendingStops) {

                        callbacks.pendingStops(pendingStopsArray);

                    } else if (callbacks.noPendingStops) {
                        callbacks.noPendingStops();

                    }

                }

            }
        });

    };


    this.checkForPendingStops = function () {

        var getPendingStops = (function (closure) {
            return closure.getPendingStops;
        })(this);

        var pedingStopsForm = (function (closure) {
            return function (pendingStopsArray) {
                closure.setPendingList(pendingStopsArray);
                closure.showPendingStopsForm();
            };
        })(this);

        var arriveDestinationForm = (function (closure) {
            return closure.showDepartForm;
        })(this);

        this.loadRouteStops({
            analizeData: getPendingStops,
            pendingStops: pedingStopsForm,
            noPendingStops: arriveDestinationForm
        });

    };

    this.successCallback = function () {
      if (parentSelector === '#RouteSummary') {
        const router = new App.Routers.RouteSummaryRoutes();

        Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');
        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, true);
      } else {
        successCallback?.();
      }

      this.modalForm.closeModalWindow();
    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope("#formArriveDestinationFormTemplate");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

    /**
     * Faz algumas modificações no ambiente onde o modal será inserido, nesse caso, modifica
     * o CSS do overlay para que ele se ajuste ao esquema de posicionamento dessa aba.
     */

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    this.validateForm = function () {

        var isValid = true;
        var arriveDestinationTime = document.getElementById("arriveDestinationTime");
        var actualArriveDestination = this.route.get("actualArriveDestination");
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formArriveDestinationFormTemplate';

        var cancelCodeElement = document.querySelector(
            "#formArriveDestinationFormTemplate #cancelCodesList"
        );

        var formatToCreate = Monet.I18n.locale.dateFormat + ' ' + Monet.I18n.locale.timeFormat;

        var arriveDestinationTimeTimeMili = null;

        try {

            if (cancelCodeElement && !cancelCodeElement.value) {
                utils.showErrorMessage(
                    scopeMessage,
                    "cancelCodeId",
                    "Route.ADest.NoCancelCodeSelected"
                );

                isValid = false;

            } else if (arriveDestinationTime.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "arriveDestination_date",
                    "Route.ADest.cantArriveWhitouDate"
                );

                isValid = false;

            } else {

                arriveDestinationTimeTimeMili = Monet.Format.DateTime.parseLocale(arriveDestinationTime.value).getTime();
                if (actualArriveDestination) {

                    utils.showErrorMessage(
                        scopeMessage,
                        "already_arriveDestinationed",
                        "Route.ArriveDestination.cantArriveArrivedDestination"
                    );

                    isValid = false;

                } else {

                    if (arriveDestinationTimeTimeMili >= new Date().getTime()) {

                        utils.showErrorMessage(
                            scopeMessage,
                            "driver",
                            "Rotue.Arrive.cantDoItTheFuture"
                        );

                        isValid = false;

                    }
                }

            }

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this,
                "No validate form.", e);
            error.console();

        }

        return isValid;
    };

    /**
     * Monta a estrutura base do formulário, pega o template e insere o conteúdo no modalForm
     */

    this.createForm = function () {

        var modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        var error = null;
        var date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {

            modalContainer.appendChild(this.getLayoutArriveDestinationFormTemplate({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.btnExit'),
                dateTimeField: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.dateTimeFieldLabel'),
                    name: 'arriveDestinationTime',
                    value: date.getCurrentDateAndTime()
                },
                drivers: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.driversList'),
                    name: 'driversList'
                }
            }));
            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No .popupFormContainer found.");
            error.console();
        }

    };

    this.createFormCancelCodes = function () {

        var modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        var error = null;
        var date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {

            modalContainer.appendChild(this.getLayoutArriveDestinationFormTemplatePendingStops({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.PendingStops.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Route.ArriveDestination.PendingStops.btnExit'),
                dateTimeField: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.PendingStops.dateTimeFieldLabel'),
                    name: 'arriveDestinationTime',
                    value: date.getCurrentDateAndTime()
                },
                cancelCodes: {
                    label: Monet.I18n.getResourcesByKey('Greenmile.Route.PendingStops.CancelCodesList'),
                    name: 'cancelCodesList'
                },
                pendingListStopHTML: renderContentListStops(),
                pendingListTitle: Monet.I18n.getResourcesByKey('Greenmile.Route.PendingStops.Title')
            }));

            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No .popupFormContainer found.");
            error.console();
        }

    };

    this.loadData = function () {

        const that = this;
        const data = {
          criteriaChain: [
            {
              and: [
                {
                  attr: "route.id",
                  eq: this.route.get("id")
                }
              ]
            }
          ]
        };

        const request = new DefaultRequest({
            url: 'RouteDriver/restrictions?criteria={"filters" : ["*","driver.name", "driver.id"]}',
            method: 'post',
            data,
            success: function (data) {

                that.populateDriversList(data);

            }
        });
        request.send();

    };

    this.loadCancelCodes = function () {
      const that = this;
      const request = new DefaultRequest({
          url: 'CancelCode/restrictions?criteria={"filters" : ["description", "id"]}',
          method: 'post',
          data: {
            criteriaChain: [
              {
                and:[
                  {
                    attr: "enabled",
                    eq: true
                  }
                ]
              }
            ]
          },
          success: function (data) {
            that.populateCancelCodeList(data);
          }
      });
      request.send();
    };

    this.populateDriversList = function (drivers) {
        const undeliverableCodeElement = document.querySelector("#formArriveDestinationFormTemplate #driversList");
        const selectDriver = document.querySelector("#driversList");
        const labelDriver = document.querySelector("label[for='driversList']");

        if (typeof(drivers) !== "undefined") {
            if (drivers.length > 0) {
                selectDriver.style.display = 'block';
                labelDriver.style.display = 'block';
                undeliverableCodeElement.innerHTML = "";

                for (let i = 0, j = drivers.length; i < j; i++) {
                    const option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);
                }
            } else {
                selectDriver.style.display = 'none';
                labelDriver.style.display = 'none';
            }
        } else {
            new Monet.Exception.ReturnError(this,"No collection loaded")
                .console();
        }

    };

    this.populateCancelCodeList = function (cancelCodes) {

        var cancelCodesElement = document.querySelector("#formArriveDestinationFormTemplate #cancelCodesList");
        cancelCodesElement.style.display = 'block';

        var driverLabel = document.querySelector("label[for='cancelCodesList']");
        var error = null;

        if (cancelCodes) {

            if (cancelCodes.length > 0) {

                driverLabel.style.display = 'block';

                cancelCodesElement.innerHTML = "";

                for (var i = 0, j = cancelCodes.length; i < j; i++) {

                    var option = document.createElement("option");

                    option.value = cancelCodes[i].id;
                    option.text = cancelCodes[i].description;

                    cancelCodesElement.appendChild(option);
                }
            }

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();
        }

    };

    this.addEventListenners = function () {

        var error = null;

        try {

            var that = this;
            var btnSave = document.querySelector("#formArriveDestinationFormTemplate #btn_save_arriveDestination_stop");
            var btnExit = document.querySelector("#formArriveDestinationFormTemplate #btn_exit_arriveDestination_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doArriveDestination();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.", e);
            error.console();

        }

    };

    this.addEventListennersPendingStops = function () {

        var error = null;

        try {

            var that = this;

            var btnSave = document.querySelector("#formArriveDestinationFormTemplate #btn_save_arriveDestinationPendingStops_stop");
            var btnExit = document.querySelector("#formArriveDestinationFormTemplate #btn_exit_arriveDestinationPendingStops_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doBatchCancellation();
            };

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No add event listenner to form.", e);
            error.console();

        }

    };

    this.updatePendingStops = function (pendingStopsArray) {

        this.setPendingList(pendingStopsArray);

        var listStops = document.querySelector('#formArriveDestinationFormTemplate .pendingStopsList');

        if (listStops) {

            listStops.innerHTML = renderContentListStops();
        }

    };

    this.requestArriveDestination = function (dataToSend, callbacks) {

        var driverParameter = '';

        if (dataToSend.driverId !== "") {
            driverParameter = "/Driver?id=" + dataToSend.driverId;
        } else {
            driverParameter = "/NoDriver";
        }

        const request = new DefaultRequest({
            url: 'Route/' + this.route.get("id") + '/ArriveDestination' + driverParameter,
            method: 'post',
            data: '{"actualArrival": "' + dataToSend.actualArrival + '"}',
            success: function (data) {
                if (typeof callbacks !== "undefined") {
                    callbacks.success(data);
                }
            },
            error: function (data) {
                if (typeof callbacks !== "undefined") {
                    callbacks.error(data);
                }
            }
        });
        request.send();

    };

    this.doArriveDestination = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var error = null;
        var that = this;

        var successCall = (function (that) {
            return function () {
                that.successCallback();
            };
        })(this);

        if (isValid) {

            if (this.route !== null) {
                this.modalForm.toggleLoadingInModalBtn();

                formDataJson = this.getFormValues();

                this.requestArriveDestination(formDataJson, {
                    success: successCall,
                    error: function (data) {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.errorCallback(data);
                    }
                });

            } else {
                error = new Monet.Exception.ReturnError(this,
                    "route can't be null");
                error.console();
            }
        }

    };

    this.batchCancelStop = function (listPendingStops, callbacks) {

        var actualArrival = this.getFormValues().actualArrival;
        var actualCancel = Monet.Format.DateTime.formatToISOString(actualArrival, { minutesOffset: -1 });
        listPendingStops.actualCancel = actualCancel;

        var request = new Monet.Ajax();
        var url = 'Route/' + this.route.get('id') + '/Stop/Cancel';

        request.timeout = 30000000;
        request.method = 'post';
        request.url = url;

        request.data = listPendingStops;

        request.success = callbacks.success;
        request.error = callbacks.error;

        request.send();

    };

    this.doBatchCancellation = function () {

        var that = this;
        var isValid = that.validateForm();
        var cancelCodeElement = document.querySelector(
            "#formArriveDestinationFormTemplate #cancelCodesList"
        );
        var stopsList = {
            stops: []
        };

        var cancelCode = {
            id: cancelCodeElement.value
        };

        if (isValid) {

            showLoading();

            for (var i = 0, j = this.pendingList.length; i < j; i++) {

                var pendingStop = this.pendingList[i];

                stopsList.stops.push({
                        key: pendingStop.get('key'),
                        cancelCode: cancelCode
                    }
                );

            }

            var success = function (context) {

                return function () {

                    var formDataJson = context.getFormValues();

                    var success = function () {
                        context.successCallback();
                    };

                    var error = function (data) {
                        context.errorCallback(data);
                        destroyLoading();
                    };

                    context.requestArriveDestination(formDataJson, {
                        success: success,
                        error: error
                    });

                };

            }(this);

            var error = function (context) {

                return function (data) {

                    var analizeData = function (context) {
                        return context.getPendingStops;
                    }(context);

                    var pendingStops = function (context) {
                        return function (pendingStopsArray) {
                            context.updatePendingStops(pendingStopsArray);
                        };
                    }(context);

                    var callbacks = {
                        analizeData: analizeData,
                        pendingStops: pendingStops
                    };

                    destroyLoading();
                    context.errorCallback(data);
                    context.loadRouteStops(callbacks);

                };

            }(this);

            var callbacks = {
                success: success,
                error: error
            };

            this.batchCancelStop(stopsList, callbacks);
        }

    };

    this.createAllStructure = function (scope) {

        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadData();
            scope.addEventListenners();
        };

    }(this);

    this.createAllStructureToPendingStops = function (scope) {

        return function () {
            scope.prepareToCreateForm();
            scope.createFormCancelCodes();
            scope.loadCancelCodes();
            scope.addEventListennersPendingStops();
        };

    }(this);

    var init = function (scope) {

        return function (scope) {

            const selector = parentSelector;

            scope.modalForm = new Monet.Form.Modal(
                selector,
                {
                    width: 280,
                    height: 250
                },
                {
                    onAfterShowModalForm: scope.createAllStructure
                },
                scope.blockOverlaySelector
            );

            scope.pendingStopsModalForm = new Monet.Form.Modal(
                selector,
                {
                    width: 600,
                    height: 448
                },
                {
                    onAfterShowModalForm: scope.createAllStructureToPendingStops
                },
                scope.blockOverlaySelector
            );

        }(scope);

    };


    this.show = function () {
        this.checkForPendingStops();
    };

    this.showDepartForm = (function (closure) {
        return function () {
            closure.modalForm.showModalForm();
        };
    })(this);

    this.showPendingStopsForm = (function (closure) {
        return function () {
            closure.pendingStopsModalForm.showModalForm();
        };
    })(this);

    init(this);

};
